<!-- 权益活动H5 -->
<template>
  <div
    class="right-activity-h5"
    :class="{ 'is-list': logged }"
    :style="backgroundStyle"
  >
    <div class="error-tip" v-if="errorMsg">{{ errorMsg }}</div>
    <template v-else-if="activityInfo.activityNo">
      <LoginForm
        v-if="!logged"
        :activity-no="activityNo"
        :title="activityInfo.title"
        @success="onLoginSuccess"
      />
      <div class="list-panel" v-else>
        <PrizeList @expired="onExpired" />
      </div>
    </template>
  </div>
</template>
<script>
import { getActivity, RIGHT_ACTIVITY_TOKEN_KEY } from '@/api/rightActivityH5'
import LoginForm from './components/LoginForm.vue'
import PrizeList from './components/PrizeList.vue'

// token对应的活动编号，避免不同活动之间复用登录态
const TOKEN_ACTIVITY_KEY = 'rightActivityNo'

export default {
  name: 'RightActivityH5',
  components: { LoginForm, PrizeList },
  data() {
    return {
      activityNo: '',
      activityInfo: {
        title: '',
        backgroundUrl: '',
        activityNo: '',
      },
      logged: false,
      errorMsg: '',
    }
  },
  computed: {
    backgroundStyle() {
      const url = this.activityInfo.backgroundUrl || this.activityInfo.topUrl || ''
      // 图片链接可能含空格、括号，必须加引号；去掉http协议头跟随当前页面协议
      return url
        ? { backgroundImage: `url("${url.replace(/^http:/, '')}")` }
        : {}
    },
  },
  created() {
    this.activityNo = this.$route.query.activityNo || ''
    if (!this.activityNo) {
      this.errorMsg = '活动参数缺失，请确认活动链接是否正确'
      return
    }
    this.logged = !!sessionStorage.getItem(RIGHT_ACTIVITY_TOKEN_KEY) &&
      sessionStorage.getItem(TOKEN_ACTIVITY_KEY) === this.activityNo
    this.getActivity()
    document.body.style.overflow = 'hidden'
  },
  beforeDestroy() {
    document.body.style.overflow = ''
  },
  methods: {
    // 获取活动信息
    getActivity() {
      getActivity(this.activityNo).then(res => {
        if (res.code === 0 && res.data) {
          if (Number(res.data.enable) !== 1) {
            this.errorMsg = '该活动不存在'
            this.logged = false
            sessionStorage.removeItem(RIGHT_ACTIVITY_TOKEN_KEY)
            sessionStorage.removeItem(TOKEN_ACTIVITY_KEY)
            return
          }
          this.activityInfo = res.data
          if (res.data.title) document.title = res.data.title
        } else {
          this.errorMsg = res.message || '该活动不存在'
        }
      }).catch(() => {
        this.errorMsg = '活动信息获取失败，请稍后重试'
      })
    },
    onLoginSuccess(token) {
      sessionStorage.setItem(RIGHT_ACTIVITY_TOKEN_KEY, token || '')
      sessionStorage.setItem(TOKEN_ACTIVITY_KEY, this.activityNo)
      this.logged = true
      this.$toast.success('登录成功')
    },
    // 登录态失效，退回登录页重新验证
    onExpired() {
      sessionStorage.removeItem(RIGHT_ACTIVITY_TOKEN_KEY)
      sessionStorage.removeItem(TOKEN_ACTIVITY_KEY)
      this.logged = false
      this.$toast.fail('登录已过期，请重新登录')
    },
  },
}
</script>
<style lang="less">
/* bank rootValue=37.5，本项目=75，样式 px 按 2 倍书写以对齐视觉尺寸 */
.right-activity-h5 {
  box-sizing: border-box;
  height: 100vh;
  max-height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 80px 40px;
  background-color: #f4f6fa;
  background-image: linear-gradient(180deg, #ffd9c6 0%, #f4f6fa 60%);
  background-repeat: no-repeat;
  background-position: top center;
  background-size: 100% 100%;

  &.is-list {
    justify-content: flex-start;
    padding: 200px 24px 40px;
  }
  .list-panel {
    height: calc(100vh - 240px);
    max-height: calc(100vh - 240px);
    display: flex;
    flex-direction: column;
    overflow: hidden;
    padding: 32px 24px 16px;
    border-radius: 32px;
    background: rgba(255, 255, 255, 0.88);
  }
  .error-tip {
    margin: auto 0;
    padding: 60px 40px;
    font-size: 30px;
    color: #8a93a6;
    text-align: center;
    line-height: 1.6;
  }
}
</style>
